import React, { Component } from 'react';
import fallbackEmbed from "./assets/images/no-media-fallback.jpg";

interface APEmbedProps {
    embedSrc: string,
    embedFallback: string,
    embedClass: string,
    title?: string
}

interface APEmbedState {
    src: string,
}

class APEmbed extends Component<APEmbedProps, APEmbedState> {

    constructor(props: any) {
        super(props);
        this.state = {
            src: props.embedSrc
        };
    }

    render() {
        const { embedClass, title } = this.props;
        const { src } = this.state;

        return (
            <embed width="100%" height="100%" src={src} title={title} type="application/pdf" className={embedClass} />
        )
    }

    static defaultProps = { embedFallback: fallbackEmbed };

}


export default APEmbed;